<template>
  <div>
    <div class="soluBanner">
      <el-carousel indicator-position="none" :interval="5000">
        <el-carousel-item
          v-if="bannerList.length > 0"
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <img :src="item.bannerPath" alt />
        </el-carousel-item>
      </el-carousel>
      <div class="soluBanBox">
        <!--        <h1>{{ solutionDetail.name }}</h1>
                <div class="soluBanText">
                  <p>{{ solutionDetail.description }}</p>
        </div>-->
      </div>
      <div
        v-if="!type"
        :class="isScroll ? 'solutionDetailTabs fixedClass' : 'solutionDetailTabs absoluteClass'"
        ref="solutionDetailTabsRef"
      >
        <div class="solutionDetailTabBox flex">
          <div
            v-for="(items, index) in solutionTabs"
            :key="index"
            @click="getSolutionTabs(index)"
            :class="solutionTabsIndex == index
                            ? 'detailTabBox_active'
                            : 'detailTabBox'
                        "
          >{{ items.names }}</div>
        </div>
      </div>
    </div>
    <div class="detailsBox">
      <div class="detailsTop1" ref="detailsTops1">
        <h3 class="detailsTitle">概述</h3>
        <div class="flex videoBox">
          <p class="videoTopP">{{ solutionDetail.summary }}</p>
          <video-player
            v-if="solutionDetail.videoUrl"
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsline="false"
            :options="playerOptions"
          ></video-player>
        </div>
      </div>
      <div class ref="detailsTops2">
        <h3 class="detailsTitle">详情</h3>
        <div v-html="solutionDetail.content" class="editorStyleDetailContent vHtmlMess"></div>
      </div>
      <div class="detailsTop3" ref="detailsTops3" name="tabs" v-if="type != 'buttJoint'">
        <h3 class="detailsTitle">咨询</h3>
        <div class="consulting">
          <div class="consultingTop flex">
            <div class="flex consultingTopInput">
              <p>
                <span class="red">*</span> 需求名称
              </p>
              <input type="text" v-model="solutionConsult.title" :disabled="!$store.state.isLogin" />
            </div>

            <div class="flex consultingTopInput">
              <p>企业名称</p>
              <input
                type="text"
                v-model="solutionConsult.enterpriseName"
                :disabled="!$store.state.isLogin"
              />
            </div>
            <div class="flex consultingTopInput">
              <p>
                <span class="red">*</span> 联系电话
              </p>
              <input type="text" v-model="solutionConsult.phone" :disabled="!$store.state.isLogin" />
            </div>
            <div class="flex consultingTopInput">
              <p>
                <span class="red">*</span> 联系人
              </p>
              <input
                type="text"
                v-model="solutionConsult.contactName"
                :disabled="!$store.state.isLogin"
              />
            </div>
          </div>
          <div class="consultingCenter flex">
            <p>
              <span class="red">*</span> 需求内容
            </p>
            <!-- <el-input
                          type="textarea"
                          placeholder="请输入内容"
                          v-model="textarea"
                          maxlength="30"
                          show-word-limit
                        >
            </el-input>-->
            <textarea
              name
              id
              cols="30"
              rows="10"
              v-model="solutionConsult.content"
              :disabled="!$store.state.isLogin"
            ></textarea>
          </div>
          <div class="consultingBottom flex">
            <p>上传文件</p>
            <el-upload
              class="upload-demo"
              ref="upload"
              accept=".jpg, .jpeg, .png, .xlsx, .xls, .docx, .dox, .pdf, .txt, .pptx, .JPG, .JPEG, .PBG, .GIF, .BMP, .PDF, .XLSX, .XLS, .DOCX, .DOX, .TXT, .PPTX"
              action="/service-center/upload/file/single"
              :before-upload="fileTypeVerification"
              :limit="5"
              :headers="headers"
              :file-list="fileList"
              :on-remove="handleRemove"
              :on-success="handleAvatarSuccess"
              :auto-upload="true"
              :disabled="!$store.state.isLogin"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                :disabled="!$store.state.isLogin"
              >选取文件</el-button>
            </el-upload>
            <span class="red" v-if="fileList.length == 0">*未选择任何文件 注意：单个附件大小不能超过2M</span>
          </div>
          <div class="consultingButton">
            <button @click="goLogin" v-if="!$store.state.isLogin" style="background: #ccc;">请先登录</button>
            <button @click="saveSolutionConsult" v-else>提交咨询</button>
          </div>

          <div class="container">
            <alerter v-if="alertManager.show" :type="alertManager.type" :title="alertManager.title"></alerter>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alert from "./alert.vue";
import { mapState } from "vuex";

import {
  getSolutionDetail,
  saveSolutionConsult,
  editCaseDetalis
} from "../../utils/interface";

export default {
  //   解决方案
  name: "solution",
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          // set meta
          name: "keywords",
          content: this.metaKeywords
        },
        {
          // set meta
          name: "description",
          content: this.metaDescription
        }
      ]
    };
  },
  components: {
    alerter: alert
  },
  data() {
    return {
      uuid: "",
      textarea: "",
      solutionDetail: "",
      bannerList: [],
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      solutionConsult: {
        contactName: "",
        phone: "",
        enterpriseName: "",
        title: "",
        content: "",
        solutionItemUuid: "",
        fileList: []
      },
      alertManager: {
        show: false,
        type: "",
        title: ""
      },
      fileName: "",
      fileList: [],
      solutionTabs: [
        {
          names: "概述"
        },
        {
          names: "详情"
        },
        {
          names: "咨询"
        }
      ],
      solutionTabsIndex: "0",
      setIn: null,
      isScroll: false,
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false //全屏按钮
        }
      },
      metaTitle: "",
      metaKeywords: "",
      metaDescription: "",
      type: ""
    };
  },
  created() {
    this.uuid = this.$route.params.uuid;
    this.type = this.$route.query.type;
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getSolutionDetail(this.type);
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor"
    })
  },
  mounted() {
    let hash = window.location.hash;
    let indexs = hash.lastIndexOf("tabs");
    let detailsTabs = this.$refs.detailsTops3;
    if (indexs != -1) {
      setTimeout(() => {
        if (detailsTabs) {
          window.scrollTo({
            top: detailsTabs.offsetTop - 200,
            behavior: "smooth"
          });
        }
      }, 500);
    } else {
      window.scrollTo(0, 0);
    }
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // alert(show, type, title, autoHide) {
    //   this.alertManager = {
    //     show: show,
    //     type: type,
    //     title: title,
    //   };
    //   if (autoHide === true) {
    //     let that = this;
    //     setTimeout(function () {
    //       that.alertManager.show = false;
    //     }, 2000);
    //   }
    // },
    goLogin() {
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！");
        this.$router.push("/login");
        // this.$message.error("您需要先登陆哦！")
        return false;
      }
    },
    saveSolutionConsult() {
      const reg = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/;
      if (
        this.solutionConsult.title.trim() == "" ||
        this.solutionConsult.phone.trim() == "" ||
        !reg.test(this.solutionConsult.phone) ||
        this.solutionConsult.contactName.trim() == "" ||
        this.solutionConsult.content.trim() == ""
      ) {
        if (this.solutionConsult.title.trim() == "") {
          this.$alert("需求名称不能为空", "提示", {
            confirmButtonText: "确定"
          });
          return;
        } else if (this.solutionConsult.phone.trim() == "") {
          this.$alert("联系电话不能为空", "提示", {
            confirmButtonText: "确定"
          });
        } else if (!reg.test(this.solutionConsult.phone)) {
          this.$alert("联系电话不正确，请确认后再输入!", "提示", {
            confirmButtonText: "确定"
          });
        } else if (this.solutionConsult.contactName.trim() == "") {
          this.$alert("联系人不能为空", "提示", {
            confirmButtonText: "确定"
          });
        } else if (this.solutionConsult.content.trim() == "") {
          this.$alert("需求内容不能为空", "提示", {
            confirmButtonText: "确定"
          });
        }
      } else {
        for (let i = 0; i < this.fileList.length; i++) {
          this.solutionConsult.fileList.push({
            filePath: this.fileList[i].url,
            fileName: this.fileList[i].name,
            consultUuid: this.uuid
          });
        }
        this.solutionConsult.solutionItemUuid = this.uuid;
        this.solutionConsult.type = this.type == "cases" ? "CASE" : "PLAN";
        saveSolutionConsult(this.solutionConsult).then(res => {
          if (res.success) {
            // this.alert(true, "success", "", true);
            /*this.$alert("提交成功", "提示", {
                            confirmButtonText: "确定",
                            callback: (action) => {
                                this.$message({
                                    type: "info",
                                    // message: `action: ${action}`,
                                });
                            },
                        });*/
            this.$message.success(res.message);
            this.fileList = [];
            this.solutionConsult.fileList = [];
            this.solutionConsult.title = "";
            this.solutionConsult.enterpriseName = "";
            this.solutionConsult.phone = "";
            this.solutionConsult.content = "";
            this.solutionConsult.contactName = "";
          } else {
            this.$message.error(res.message);
          }
          console.log(res);
        });
      }

      // if (!reg.test(this.solutionConsult.phone)) {
      //   this.alert(true, "fail", "联系电话不正确，请确认后再输入!", true);
      //   return;
      // }

      // if (this.solutionConsult.contactName.trim() == "") {
      //   this.alert(true, "fail", "联系人不能为空", true);
      //   return;
      // }
      // if (this.solutionConsult.content.trim() == "") {
      //   this.alert(true, "fail", "需求内容不能为空", true);
      //   return;
      // }
    },

    handleAvatarSuccess(obj, fileList) {
      console.log(obj);
      this.fileList.push(obj);
    },

    handleRemove(obj, fileList) {
      this.fileList = fileList;
    },
    fileTypeVerification(file) {
      let str = file.name.substring(file.name.indexOf("."));
      if (
        str != ".txt" &&
        str != ".jpg" &&
        str != ".jpeg" &&
        str != ".png" &&
        str != ".xlsx" &&
        str != ".xls" &&
        str != ".docx" &&
        str != ".dox" &&
        str != ".pdf" &&
        str != ".pptx"
      ) {
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 2;
      if (!fileSize) {
        return false;
      }
    },

    getSolutionDetail(type) {
      if (type == "buttJoint") {
        // 对接案例
        editCaseDetalis({ id: this.uuid }).then(res => {
          if (res.success) {
            res.data.bannerEntity.map(item => {
              item.bannerPath = item.url;
            });
            res.data.summary = res.data.info;
            res.data.content = res.data.details;
            this.solutionDetail = res.data;
            this.metaTitle = res.data.title + "-水泵云";
            this.bannerList = res.data.bannerEntity;
          }
        });
      } else {
        getSolutionDetail(this.uuid).then(res => {
          if (res.videoUrl != "") {
            this.playerOptions.sources[0].src = res.videoUrl;
          }
          this.solutionDetail = res;
          this.solutionDetail.content = this.solutionDetail.content.replace(
            "video-js",
            "video-js1"
          );
          this.solutionDetail.content = this.solutionDetail.content.replace(
            'preload="none"',
            'preload=""'
          );
          this.metaTitle = res.name + "-" + res.programName + "-水泵云";
          this.metaKeywords = res.metaKeywords;
          this.metaDescription = res.metaDescription;
          this.bannerList = this.solutionDetail.bannerList;
        });
      }
    },
    getSolutionTabs(i) {
      let detailsTops1 = this.$refs.detailsTops1;
      let detailsTops2 = this.$refs.detailsTops2;
      let detailsTops3 = this.$refs.detailsTops3;

      this.solutionTabsIndex = i;
      if (i == 0) {
        window.scrollTo({
          top: detailsTops1.offsetTop - 200,
          behavior: "smooth"
        });
      } else if (i == 1) {
        window.scrollTo({
          top: detailsTops2.offsetTop - 150,
          behavior: "smooth"
        });
      } else if (i == 2) {
        window.scrollTo({
          top: detailsTops3.offsetTop - 200,
          behavior: "smooth"
        });
      }

      // console.log(detailsTops1.offsetTop);
    },
    // 滚动固定导航栏
    handleScroll() {
      // this.$nextTick(() => {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 480) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
      if (
        this.$refs.detailsTops1.offsetHeight &&
        this.$refs.detailsTops2.offsetHeight
      ) {
        let detailsTops1Height = this.$refs.detailsTops1.offsetHeight;
        let detailsTops2Height = this.$refs.detailsTops2.offsetHeight;
        if (scrollTop < 480 + detailsTops1Height) {
          this.solutionTabsIndex = 0;
        } else if (
          scrollTop > 480 + detailsTops1Height &&
          scrollTop < 380 + detailsTops1Height + detailsTops2Height
        ) {
          this.solutionTabsIndex = 1;
        } else {
          this.solutionTabsIndex = 2;
        }
      }
      // })
    }
  }
};
</script>

<style scoped lang="less">
.blue {
  color: #009999;
}

.red {
  color: #d60000;
  margin-left: 10px;
}

.soluBanner {
  position: relative;
  width: 100%;
  height: 500px;

  img {
    width: 100%;
    height: 500px;
    display: block;
  }

  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    z-index: 99;

    h1 {
      font-size: 38px;
    }

    .soluBanText {
      margin: 8px 0 60px;

      p:nth-child(1) {
        font-size: 17px;
      }

      p:nth-child(2) {
        font-size: 9px;
      }
    }
  }

  .solutionDetailTabs {
    width: 100%;
    height: 63px;
    z-index: 99;

    &.fixedClass {
      position: fixed;
      top: 80px;
      background: #000;
    }

    &.absoluteClass {
      position: absolute;
      bottom: 0px;
      background: #5c91ab4d;
    }

    .solutionDetailTabBox {
      width: 1200px;
      margin: 0 auto;
      line-height: 63px;
      color: #fff;

      .detailTabBox {
        cursor: pointer;
        flex: 1;
        text-align: center;
      }

      .detailTabBox:hover {
        flex: 1;
        text-align: center;
        background: #5c91aba1;
      }

      .detailTabBox_active {
        flex: 1;
        text-align: center;
        background: #5c91aba1;
      }
    }
  }
}

.detailsBox {
  width: 1200px;
  margin: 0 auto;

  .videoBox {
    align-items: center;
    justify-content: space-between;

    .videoTopP {
    }

    .vjs-custom-skin {
      width: 44%;
      flex-shrink: 0;
      margin-left: 20px;
    }
  }
  ///deep/ .video-js{
  //  width: 100% !important;
  //  height: 100%  !important;
  //  margin: 10px auto;
  //}

  .detailsTitle {
    border-bottom: 2px solid #009999;
    width: 45px;
    color: #009999;
    margin-bottom: 16px;
  }

  .detailsTop1 {
    margin-top: 40px;

    p {
      text-indent: 2em;
      line-height: 28px;
      font-size: 15px;
      color: #777;
    }

    p:nth-child(3) {
      margin-top: 16px;
    }
  }

  .detailsTop2 {
    margin-top: 40px;
    line-height: 28px;
    color: #777;
    font-size: 15px;

    /deep/ span {
      text-indent: 2em;

      color: #777 !important;
      font-size: 15px !important;
    }
  }

  .detailsTop3 {
    margin-bottom: 40px;
    margin-top: 30px;

    .consulting {
      width: 1200px;
      border-radius: 10px;
      // box-shadow: 0px 1px 7px 0px #dadada;
      padding: 30px 40px;
      margin: 0 auto;
      font-size: 14px;
      color: #777;
      box-sizing: border-box;

      .consultingTop {
        align-items: center;
        justify-content: space-between;

        .consultingTopInput {
          align-items: center;

          p {
            flex-shrink: 0;
            width: 80px;
            text-align: right;
          }

          input {
            border: none;
            background: #f5f5f5;
            border-radius: 4px;
            margin-left: 15px;
            padding: 6px;
            width: 64%;
            color: #777;
            box-sizing: border-box;
          }
        }
      }

      .consultingCenter {
        margin-top: 25px;

        p {
          width: 80px;
          text-align: right;
          flex-shrink: 0;
        }

        textarea {
          width: 91%;
          border: none;
          background: #f5f5f5;
          border-radius: 4px;
          margin-left: 11px;
          padding: 6px;
          color: #777;
          height: 200px;
        }
      }

      .consultingBottom {
        margin-top: 25px;
        align-items: center;

        button {
          border: none;
          background: #099;
          border-radius: 4px;
          margin-left: 15px;
          padding: 6px 18px;
          color: #fff;
        }

        p {
          width: 75px;
          text-align: right;
        }

        p:nth-last-child(1) {
          font-size: 12px;
          color: #d60000;
          margin-left: 10px;
        }
      }

      .consultingButton {
        text-align: center;
        margin-top: 20px;

        button {
          cursor: pointer;

          border: none;
          background: #099;
          border-radius: 4px;
          margin-left: 15px;
          padding: 6px 18px;
          color: #fff;
        }
      }
    }
  }
}

/deep/ .el-carousel__container {
  height: 500px;
}

/deep/ .el-upload-list__item-name {
  padding-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/solution/caseDetails.vue